import React from "react"
import { Link, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react"
import { capsStringAll } from "../../../utils"
import { Link as GatsbyLink } from "gatsby"
import { Icon } from "../../"

export default function DesktopDropdown({ url, label, style }) {
  const itemStyle = {
    ...style,
    ...{
      _hover: { bg: "base.900", color: "#ffffff" },
      _focus: { bg: "base.900", color: "#ffffff" },
      py: 2,
    },
  }

  return (
    <Menu isLazy>
      <MenuButton as={Link} {...style}>
        {label}
        <Icon name="chevronDown" ml={2} boxSize={2} />
      </MenuButton>

      <MenuList
        borderColor="base.800"
        position="absolute"
        boxShadow="none"
        bg="base.d200"
      >
        {url.map(({ fields }, index) => {
          return (
            <MenuItem
              key={index}
              as={GatsbyLink}
              to={fields.slug}
              {...itemStyle}
            >
              {capsStringAll(fields.slug.split("/")[2])}
            </MenuItem>
          )
        })}
      </MenuList>
    </Menu>
  )
}
